// extracted by mini-css-extract-plugin
export default {"root":"SiteCard_root__6YYTn","header":"SiteCard_header__R1cyZ","counter":"SiteCard_counter__O3u5t"};